import Vue from 'vue';
import '@/vue.js';

import ImproveFormContent from '@/web/form/ImproveFormContent';

Vue.component('improve-form-content', ImproveFormContent);

const app = new Vue({
  el: '#content',
});
